import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { formatCollectionAndFieldName } from './common/common_utils';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class SupabaseEdit extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  async componentDidMount() {
    const { actions } = this.props;
    const { dbUuid, projectId, version } = this.props.match.params;
    await actions.getSupabaseExternalDb({ version, projectId, dbUuid });
    await actions.collectionListExternaldbs({ projectId, dbUuid, version });
  }
  handleCreateButtonClick = (item, index) => {
    const { match, history } = this.props;
    const { projectId, dbUuid, version } = match.params;
    history.push(`/2.0/data-connector/${version}/v/${projectId}/supabase-schema/${dbUuid}`, {
      collectionIndex: index,
    });
  };

  handleUpdate = (obj, index) => {
    const { projectId, dbUuid, version } = this.props.match.params;
    this.props.history.push(
      `/2.0/data-connector/${version}/v/${projectId}/supabase-update-collection/${index}/${dbUuid}`,
      {},
    );
  };

  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };
  renderCollectionCard = (item, index) => {
    const { collectionList } = this.props.dataConnector;
    const name = item.name;
    const fields = item.fields;
    const matchingObject = collectionList.find(
      (obj) =>
        obj.orgCollectionName === name || obj.collectionName === formatCollectionAndFieldName(name),
    );
    return (
      <div className="card card--user-profile ml-4 card--collection-source col-md-4" key={index}>
        <div className="card-body">
          <div className="avatar__meta">
            {matchingObject ? (
              <h5 className="avatar__title js-user-name" title={name}>
                {name} <i className={'wb webconnect-check-circle text-success'}></i>
              </h5>
            ) : (
              <h5 className="avatar__title js-user-name" title={name}>
                {name}
              </h5>
            )}

            <p>Number of fields: {Object.keys(fields).length}</p>
            {matchingObject ? (
              <div>
                <p>Created At: {this.formatDate(new Date(matchingObject.createdAt))}</p>
                <p>Updated At: {this.formatDate(new Date(matchingObject.updatedAt))}</p>
              </div>
            ) : (
              <div>
                <p>Created At: Not yet created</p>
                <p>Updated At: Not yet updated</p>
              </div>
            )}
            {matchingObject ? (
              <button
                className="btn btn-theme-submit btn-md"
                onClick={() => {
                  this.handleUpdate(item, index);
                }}
              >
                <i className="wb webconnect-save-regular"></i> Update
              </button>
            ) : (
              <button
                className="btn btn-create btn-primary"
                onClick={() => {
                  this.handleCreateButtonClick(item, index);
                }}
              >
                <i className="wb webconnect-plus"></i>
                {' Create'}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };
  renderDataConnectorTableList = () => {
    const { dataConnector } = this.props;
    const { supabaseStoredData, getSupabaseExternalDbPending, collectionListExternaldbsPending } =
      dataConnector || '';
    const { completeData } = supabaseStoredData || '';
    const { tables } = completeData || '';
    if (getSupabaseExternalDbPending || collectionListExternaldbsPending) {
      return (
        <div className="text-center">
          <CustomLoader
            loading={collectionListExternaldbsPending || getSupabaseExternalDbPending}
            size="20px"
            color="#303453"
          />
        </div>
      );
    } else {
      return (
        <ParentContentCard title={' List of Collections via Supabase'} icon={'collection'}>
          <div className="d-flex flex-wrap">
            {tables &&
              tables.map((item, index) => {
                return this.renderCollectionCard(item, index);
              })}
          </div>
        </ParentContentCard>
      );
    }
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    return <CommonPageComponent>{this.renderDataConnectorTableList()}</CommonPageComponent>;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SupabaseEdit);
